import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import dayjs from "dayjs"
@Component({
  components: {

  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_material_warehousing_code_jian'),
        dataIndex: 'orderCode',
        key: 'orderCode',
        ellipsis: true,
        width: 200,
      },
      {
        title: this.$t('page_material_warehousing_name_jian'),
        dataIndex: 'orderName',
        ellipsis: true,
        key: 'orderName'
      },
      {
        title: this.$t('page_material_warehousing_order_code_jian'),
        dataIndex: 'planCode',
        ellipsis: true,
        key: 'planCode',
        width: 200,
      },
      {
        title: this.$t('page_material_warehousing_delivery_no_jian'),
        dataIndex: 'deliveryCode',
        ellipsis: true,
        key: 'deliveryCode',
        width: 200,
      },
      {
        title: this.$t('page_material_warehousing_feeding_ren_jian'),
        dataIndex: 'deliveryUser',
        ellipsis: true,
        key: 'deliveryUser',
        customRender: (value) => this.findUser(value)
      },
      {
        title: this.$t('page_material_warehousing_receipt_code_jian'),
        dataIndex: 'receivingCode',
        ellipsis: true,
        key: 'receivingCode',
        width: 200
      },
      {
        title: this.$t('page_material_warehousing_receipt_ren_jian'),
        dataIndex: 'receivingUser',
        ellipsis: true,
        key: 'receivingUser',
        customRender: (value) => this.findUser(value)
      },
      {
        title: this.$t('page_material_warehousing_receipt_time_jian'),
        dataIndex: 'receivingTime',
        ellipsis: true,
        key: 'receivingTime',
        width: 200,
        customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
      },
      {
        title: this.$t('page_material_warehousing_receipt_dept_jian'),
        dataIndex: 'receivingDept',
        ellipsis: true,
        key: 'receivingDept',
        customRender: (value) => this.findDept(value)
      },
      {
        title: this.$t('page_material_warehousing_receipt_type_jian'),
        dataIndex: 'stockInTypeName',
        ellipsis: true,
        key: 'stockInTypeName',
      },
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<any>;
  @Prop({ default: () => [] }) readonly staff: Array<any>;
  @Prop({ default: () => [] }) readonly listAllTree: Array<any>;
  @Prop({ default: ""}) readonly current: String;
  @Prop({ default: ""}) readonly pageSize: String;
  @Prop({ default: 0}) readonly total: Number;
  @Prop({ default: 300 }) readonly height: Number;
  @Prop({ default: ""}) readonly selectId: String;
  @Prop({ default: () => [] }) readonly selectedRowKeys: Array<any>;

  onSelectChange(selectedRowKeys) {
    this.$emit('onSelectChange',selectedRowKeys)
  }
  findUser(value){
    const user = this.staff.find(res => res.id === value)
    return user ? user.name : ""
  }
  findDept(value){
    const dept = this.listAllTree.find(res => res.key === value)
    return dept ? dept.title : ""
  }
  handleTableChange(current: number, pageSize: number) {
    const pager = {
      pageSize: pageSize,
      current: current
    }
    this.$emit('handleTableChange',pager)
  }
  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(record){
    this.$emit('clickRow',record)
  }

  render() {
    return (
      <div>
        <ml-table
          pagination={false}
          columns={this.columns}
          dataSource={this.data}
          bordered
          rowKey="id"
          selectRowKey={this.selectId}
          scroll={{ y: this.height, x: 1680 }}
          row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }}
          customRow={(record) => {
            return {
              on: { // 事件
                click: () => this.clickRow(record),      // 点击行
              },
            };
          }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          show-total={total => `${ this.showTotal(total) }`}
          current={this.current}
          total={this.total}
          pageSize={this.pageSize}
          on-change={this.handleTableChange}
          on-showSizeChange={this.handleTableChange}
        />
      </div>
    )
  }
}
